import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  IconButton,
  TextField,
  BoxProps,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Colors } from "../../utils/constants";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector, useDispatch } from "react-redux";
import { AuthorFinderObj, ReducerObj } from "../../types/interface";
// import search from "../../screens/AuthorFinder/onAuthorResult";
// import search from "../../screens/AuthorFinder/onAuthorSearch";
// import search from '../../screens/Search/onSearch';
// import { CustomTooltip } from "../MyLibrary/MyAlerts/Alerts.style";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { onAuthorResult as search } from "../../screens/AuthorFinder/onAuthorResult";

import {
  clearMarkedResult,
  clearSearchTerm,
  removeSearchTerm,
  sliceSearchTerm,
  updateMarkedArticleCount,
  updateNewSearchStatus,
  updatePage,
  updateSearchResults,
  updateSearchTerm,
} from "../../store/slice/searchSlice";
import {
  clearAllFilters,
  clearAllFiltersValue,
  clearPublicationFilter,
  removeAllFilterType,
  updateAuthor,
  updateCountryOfPublication,
  updateCountryOfPublishingAuthor,
  updateDateFrom,
  updateEarlyOnline,
  updateInstitution,
  updateJournal,
  updateJournalRank,
  updateLoadingState,
  updateMonthFrom,
  updateOpenAccess,
  updatePublisher,
  updateResearch,
  updateSourceIndexType,
  updateSourceType,
  updateSpeaker,
  updateSubject,
  updateYearFrom,
} from "../../store/slice/filterSlice";
import {
  clearAuthorDataTypeFilters,
  clearAuthorSearchTerm,
  removeAuthorSearchTerm,
  sliceAuthorSearchTerm,
  updateAbastractAuthor,
  updateAuthorDataType,
  updateAuthorFullText,
  updateAuthorInitial,
  updateAuthorNewSearchStatus,
  updateAuthorPage,
  updateAuthorRow,
  updateAuthorSearchResults,
  updateAuthorSearchTerm,
  updateAuthorSelectedTag,
  updateAuthorSubjectType,
  updateIsAuthorAnalytics,
  updateIsAuthorSettled,
} from "../../store/slice/authorFinderSlice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { useGetMySearchPreference } from "../../api/Preferences/Subjects.api";
import { isPreferenceAdded, showIsProfileToast } from "../../utils/helper";
import { setModal } from "../../store/slice/modalSlice";
import { GetMyPreferenceData } from "../../types/GetMySubjects.types";
import { CustomTooltip } from "../../screens/MyLibrary/MyAlerts/Alerts.style";
import { usagelogApi } from "../../api/usageReportApi";
import dayjs from "dayjs";

const x = [
  "Machine Cubes",
  "General Electric",
  "CT and MRI",
  "Marching Squares",
];

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 32,
  height: 19,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 18,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#177ddc" : "#31C48D",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 15,
    height: 15,
    borderRadius: 10,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 18 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,.35)"
        : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));

interface Proptype {
  totalResult?: string | number;
}

function Item(props: BoxProps) {
  const { sx, ...other } = props;
  return (
    <Box
      sx={{
        p: { xs: 0, sm: 1 },
        m: { xs: 0, sm: 1 },
        ...sx,
      }}
      {...other}
    />
  );
}

const AuthorFinderTopbar = (props: Proptype) => {
  const navigate = useNavigate();

  const searchReducer: any = useSelector(
    (state: ReducerObj) => state.searchReducer
  );

  const authorReducer: any = useSelector(
    (state: AuthorFinderObj) => state.authorReducer
  );

  const selectedFilters: any = useSelector(
    (state: ReducerObj) => state.filterReducer
  );

  const customerData = useAppSelector(
    (state) => state.customer.customerDetails
  );

  const filterReducer: any = useSelector(
    (state: ReducerObj) => state.filterReducer
  );

  const allAppliedFilter = useAppSelector(
    (state) => state.filterReducer.allAppliedFilter
  );

  const user_id = useAppSelector((state) => state.login.user_id);

  const dispatch = useAppDispatch();

  // const searchTermvalue = getParamsByName("searchterm");

  const [searchTerm, setSearchTerm] = useState("");
  const [error, setError] = useState("");

  const isPreferenceEnabled = sessionStorage.getItem("preference") === "true";

  const [isPreference, setIsPreference] = useState(isPreferenceEnabled);

  const {
    openAccess,
    retractedArticle,
    datesetAvailability,
    earlyOnline,
    dateFrom,
    monthFrom,
  } = useAppSelector((state) => state.filterReducer);

  const { yearFrom } = useAppSelector((state) => state.filterReducer);

  const trigger = useRef(0);
  const triggerPreference = useRef(0);

  const [showAll, setShowAll] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  //Get Personalized Data for Preference
  const { data: myPreference, refetch } = useGetMySearchPreference(
    user_id,
    isPreference
  );

  useEffect(() => {
    const debounce = setTimeout(() => {
      refetch();
    }, 100);

    return () => {
      clearTimeout(debounce);
    };
  }, []);

  // useEffect(() => {
  //     isPreference && applyPreference();
  // }, [isPreference, myPreference]);

  useEffect(() => {
    triggerPreference.current && applyPreference();
  }, [isPreference, myPreference]);

  function searchTermChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.value) setError("");
    setSearchTerm(e.target.value);
  }

  useEffect(() => {
    if (trigger.current) onAuthorSearch();
  }, [trigger.current]);

  useEffect(() => {
    onRefineSearch();
  }, []);

  function onRefineSearch() {
    if (!searchTerm) {
      return;
    }

    dispatch(updateAuthorSearchTerm(searchTerm));

    dispatch(updateAuthorPage(1));
    // setValue("searchterm", "");
    setSearchTerm("");
    trigger.current = trigger.current + 1;
  }

  const profileData = useSelector((state: any) => state.login);

  const profileData1 = useSelector(
    (state: any) => state.customer.customerDetails
  );

  const contextId =
    selectedFilters.collectionValue === "J-GateCollection"
      ? 1
      : selectedFilters.collectionValue === "ConsortiaSubscriptions"
      ? 2
      : selectedFilters.collectionValue === "MyLibraryCollection"
      ? 3
      : selectedFilters.collectionValue === "MyPersonalLibraryCollection"
      ? 4
      : selectedFilters.collectionValue === "ONOSCollections"
      ? 5
      : selectedFilters.collectionValue === "Library OPAC"
      ? 6
      : selectedFilters.collectionValue === "Open Access Collections"
      ? 7
      : null;

  const logAuthorResultUsageData = (usageActionID: any, data?: any) => {
    const articleArticle_Id = data?.article_id ? data?.article_id : null;
    const articleResourcemaster_id = data?.resourcemaster_id
      ? data?.resourcemaster_id
      : null;
    const articleResourceissue_id = data?.resourceissue_id
      ? data?.resourceissue_id
      : null;
    const user_ipv4_address =
      sessionStorage.getItem("user_ipv4_address") || null;

    const userMasterId = profileData.user_id ? profileData.user_id : null;
    const informaticscustomerId = profileData.informaticscustomer_id
      ? profileData.informaticscustomer_id
      : null;
    const consortiamasterId =
      profileData1 && profileData1.consortiamaster_id
        ? profileData1.consortiamaster_id
        : null;
    const sessionKey = profileData.session_key ? profileData.session_key : null;
    usagelogApi(
      userMasterId,
      informaticscustomerId,
      consortiamasterId,
      usageActionID,
      contextId,
      null,
      articleArticle_Id,
      articleResourceissue_id,
      null,
      articleResourcemaster_id,
      // profileData.ip_v4,
      user_ipv4_address,
      null,
      sessionKey,
      1,
      null,
      0
    );
  };

  async function onNewSearch() {
    dispatch(clearAllFiltersValue());
    dispatch(updateLoadingState(true));
    dispatch(updateAuthorFullText(true));

    // dispatch(updateAuthorSelectedTag("*"))
    dispatch(clearAuthorSearchTerm());
    dispatch(updateAuthorSearchTerm(searchTerm));

    dispatch(clearSearchTerm());
    dispatch(clearAllFilters());
    // dispatch(clearMarkedResult());
    dispatch(clearPublicationFilter());
    dispatch(updateSearchTerm(searchTerm));
    dispatch(updateNewSearchStatus(true));

    dispatch(updateAuthorPage(1));
    dispatch(updateAuthorRow(15));
    dispatch(updateAbastractAuthor(false));
    dispatch(updateIsAuthorAnalytics(false));

    navigate("/authorfinder");
    setSearchTerm("");
    dispatch(updateAuthorSelectedTag("*"));
    dispatch(updateAuthorInitial("*"));
    // trigger.current = trigger.current + 1;
    await dispatch(search());
    dispatch(updateMarkedArticleCount([]));
    dispatch(updateIsAuthorSettled(true));
  }

  function onRemove(value: string) {
    // dispatch(removeSearchTerm(value));

    dispatch(removeAuthorSearchTerm(value));

    const tempValue = filterReducer.author?.filter(
      (data: any) => data !== value
    );

    dispatch(updateAuthor(tempValue));
    //dispatch(removeAuthorSearchTerm(value));
    trigger.current = trigger.current + 1;
  }

  function clearAll() {
    dispatch(sliceAuthorSearchTerm());
    // dispatch(sliceSearchTerm());
    dispatch(clearAllFilters());
    trigger.current = trigger.current + 1;
  }

  // On search
  async function onAuthorSearch() {
    //  dispatch(updateLoadingState(true));
    if (authorReducer.searchTerm.length) {
      // dispatch(search());
      dispatch(search("", null, true));
      // const data = await search(authorReducer, selectedFilters, dispatch);
      // // Dispatch to redux
      // dispatch(updateAuthorSearchResults(data));
    }
    //  dispatch(updateLoadingState(false));

    dispatch(updateAuthorNewSearchStatus(false));
  }

  const removeFilter = (
    value: string,
    arr: string[],
    setterFunction: Function
  ) => {
    let filteredValues = arr.filter((data) => data !== value);
    dispatch(setterFunction(filteredValues));
    // setTriggerCount((prev) => prev + 1);
    // trigger.current = trigger.current + 1;
    // remove data from the allappliedfilter state
    dispatch(removeAllFilterType(value));

    // dispatch(search());
    dispatch(search("", null, true));
  };

  async function checkPreferenceAdded(myPreference: GetMyPreferenceData) {
    if (!myPreference) return;
    const filteredSubjectData = myPreference.Subjects?.map(
      ({ subject2_details }) =>
        subject2_details.filter(({ is_favorite }) => is_favorite)
    ).flat();

    const filteredSelectedTags = myPreference?.DataTypes.filter(
      ({ is_favorite }: any) => is_favorite
    ).map(({ datatype_id }) => datatype_id);
    if (filteredSelectedTags?.filter((ele: any) => ele !== 2)?.length === 0) {
      setIsPreference(false);
      sessionStorage.setItem("preference", "false");
    }
  }

  function handlePreference(event: React.ChangeEvent<HTMLInputElement>) {
    logAuthorResultUsageData(112);
    if (sessionStorage.getItem("isProfileUser") === "true") {
      let isMyPrefAdded: boolean = true;
      if (myPreference) {
        isMyPrefAdded = isPreferenceAdded(myPreference);
      }

      if (!isMyPrefAdded && event.target.checked) {
        dispatch(
          setModal({
            modalType: "PREFERENCE",
            modalProps: {
              open: true,
              checkPreferenceAdded,
            },
          })
        );
      }
      setIsPreference(event.target.checked);
      sessionStorage.setItem("preference", event.target.checked.toString());
    } else {
      showIsProfileToast("Please login as profile user to use the preferences");
    }
  }

  async function applyPreference() {
    if (!user_id || !customerData) return;
    if (!myPreference) return;

    //  dispatch(clearAuthorDataTypeFilters());

    if (isPreference && myPreference) {
      // Update preference data type
      const preferedSources = myPreference.DataTypes.filter(
        (type) => type.is_favorite
      )?.map((source) => source.datatype_id);

      dispatch(updateAuthorDataType(preferedSources));

      // update subject ids
      const preferedSubjects = myPreference.Subjects?.map((l1) =>
        l1.subject2_details.filter((l2) => l2.is_favorite)
      )
        .flat()
        ?.map((l2) => {
          return {
            datsubjectmasterlevel1_id: -1, //Unused, Just for Integrity's Sake
            datsubjectmasterlevel2_id: l2.subject_id2,
            level2subject_name: l2.subject_name2,
          };
        });

      const subjectIds = preferedSubjects?.map(
        (x) => x.datsubjectmasterlevel2_id
      );

      dispatch(updateAuthorSubjectType(subjectIds));
    } else {
      const subjectIds = customerData.subject?.map(
        (x: any) => x?.datsubjectmasterlevel2_id
      );
      const dataTypeIds = ["1", "2", "3", "4", "8", "24"];
      // update datatype ids
      dispatch(updateAuthorDataType(dataTypeIds));

      //Update Subject Ids
      dispatch(updateAuthorSubjectType(subjectIds));
    }
  }

  function toTitleCase(text: string) {
    const words = text.split(" ");
    const titleCasedWords = words?.map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    return titleCasedWords.join(" ");
  }

  function openPreferenceInfoModal() {
    dispatch(
      setModal({
        modalType: "PREFERENCE_INFO_MODEL",
        modalProps: {
          isOpen: true,
          from: "basicsearch",
        },
      })
    );
  }

  const buttonConfigs = [
    {
      condition: openAccess,
      onClick: () => {
        dispatch(updateOpenAccess(false));
        dispatch(search("", null, true));
      },
      label: "Open Access",
    },
    {
      condition:
        yearFrom &&
        yearFrom.toString() !==
          `[${dayjs().year()} TO ${dayjs().year()}]`.toString(),
      onClick: () => {
        dispatch(updateYearFrom(""));
        dispatch(search("", null, true));
      },
      label: yearFrom,
    },
    {
      condition:
        yearFrom &&
        yearFrom.toString() ===
          `[${dayjs().year()} TO ${dayjs().year()}]`.toString(),
      onClick: () => {
        dispatch(updateYearFrom(""));
        dispatch(search("", null, true));
      },
      label: "Current Year",
    },
    {
      condition: monthFrom,
      onclick: () => {
        dispatch(updateMonthFrom(""));
        dispatch(search("", null, true));
      },
      label: "Last One Month",
    },
    {
      condition: dateFrom,
      onClick: () => {
        dispatch(updateDateFrom(""));
        dispatch(search("", null, true));
      },
      label: "Last One Week",
    },
    {
      condition: earlyOnline,
      onClick: () => {
        dispatch(updateEarlyOnline(false));
        dispatch(search("", null, true));
      },
      label: "Early Online",
    },
  ];

  const ResponsiveFilterButtons = ({ filterArrays, configButtons }: any) => {
    const [showAll, setShowAll] = useState(false);

    // Generate filter buttons from filterArrays
    const filterButtons = filterArrays.flatMap(
      (item: { data: any[]; updateFunction: (arg0: any) => any }) =>
        item.data
          .filter((val: string) => val && val.trim() !== "")
          .map((data: string) => ({
            label: toTitleCase(
              data.split(",").reverse().join(" ").replace(",", "")
            ),
            onClick: () => item.updateFunction(data),
            type: "filter", // mark type if you want to conditionally add an icon
          }))
    );

    // Generate config buttons only if their condition is truthy
    const activeConfigButtons = configButtons
      .filter((btn: { condition: any }) => btn.condition)
      .map((btn: { label: any; onClick: any }) => ({
        label: btn.label,
        onClick: btn.onClick,
        type: "config",
      }));

    // Combine both arrays
    const allButtons = [...filterButtons, ...activeConfigButtons];

    if (allButtons.length === 0) return null;

    // Show all if toggled or just the first button
    const visibleButtons = showAll ? allButtons : allButtons.slice(0, 1);
    const remainingCount = allButtons.length - visibleButtons.length;

    return (
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap">
          {visibleButtons.map((btn, index) => (
            <Button
              key={`${btn.label}-${index}`}
              size="small"
              variant="outlined"
              // Use a CloseIcon only for filter buttons (optional)
              endIcon={<CloseIcon />}
              sx={webStyle.searchTextFont}
              onClick={btn.onClick}
            >
              {btn.label}
            </Button>
          ))}
          {allButtons.length > 1 && (
            <Button onClick={() => setShowAll(!showAll)}>
              {showAll ? "Less" : `More +${remainingCount}`}
            </Button>
          )}
        </Stack>
      </Box>
    );
  };

  return (
    <Box bgcolor={Colors.white} py={"1%"}>
      <Box
        sx={{
          paddingInline: { xs: "10px", sm: "35px", md: "66px", lg: "66px" },
        }}
      >
        <Box
          sx={{
            ...webStyle.flexRow,
            justifyContent: { xs: "space-between", sm: "initial" },
          }}
        >
          <Box sx={webStyle.flexRow}>
            <Typography sx={webStyle.textResult} variant="h5">
              Search Results
              {/* ({searchResults?.hits}) */}
            </Typography>
          </Box>
          <Box sx={[webStyle.flexRow, { alignItems: "center" }]}>
            <Typography sx={[webStyle.toogleText]}>Preferences</Typography>
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              marginLeft={"6%"}
            >
              <AntSwitch
                checked={isPreference}
                inputProps={{ "aria-label": "ant design" }}
                onChange={handlePreference}
              />
            </Stack>
            <Stack>
              <IconButton size="medium" onClick={openPreferenceInfoModal}>
                <InfoOutlinedIcon fontSize="inherit" />
              </IconButton>
            </Stack>
          </Box>
        </Box>

        <Box
          sx={{
            display: { xs: "flex", sm: "none" },
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <Button variant="outlined" sx={webStyle.button} onClick={onNewSearch}>
            New Author Search
          </Button>
        </Box>

        {/* Input box */}
        <Box sx={{ display: { xs: "none", sm: "contents" } }}>
          <Item
            sx={{
              flexShrink: 0,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={[
                webStyle.flexRow,
                {
                  marginTop: "1%",
                  marginBottom: "1%",
                  flexWrap: "wrap",
                  gap: 1,
                  alignItems: "center",
                },
              ]}
            >
              <Button sx={webStyle.clearallText} onClick={clearAll}>
                Clear All
              </Button>

              {/* {renderFilterTags()} */}
              {Array.isArray(authorReducer.searchTerm) &&
                authorReducer.searchTerm?.map((val: string, i: number) => {
                  return (
                    <Stack direction="row" spacing={2}>
                      <Button
                        size="small"
                        variant="outlined"
                        endIcon={<CloseIcon />}
                        sx={webStyle.searchTextFont}
                        onClick={() => {
                          if (i > 0) onRemove(val);
                        }}
                      >
                        {/* {val} */}

                        {toTitleCase(
                          val.split(",").reverse().join(" ").replace(",", "")
                        )}
                        {/* {val.length ? val.trim().replace(/^\,+|\,+$/g, '').trim() : ""}{" "} */}
                      </Button>
                    </Stack>
                  );
                })}

              {/* // Filters */}
              {/* SOURCE TYPE */}
              {selectedFilters.sourceType.length
                ? selectedFilters.sourceType?.map((data: string) => (
                    <Stack direction={"row"} alignItems="center">
                      <Button
                        size="small"
                        variant="outlined"
                        endIcon={<CloseIcon />}
                        sx={webStyle.searchTextFont}
                        onClick={() =>
                          removeFilter(
                            data,
                            selectedFilters.sourceType,
                            updateSourceType
                          )
                        }
                      >
                        {/* {data} */}
                        {toTitleCase(
                          data.split(",").reverse().join(" ").replace(",", "")
                        )}
                      </Button>
                    </Stack>
                  ))
                : null}

              {/* SUBJECT FILTER */}
              {selectedFilters.subject.length
                ? selectedFilters.subject?.map((data: string) => (
                    <Stack direction={"row"} alignItems="center">
                      <Button
                        size="small"
                        variant="outlined"
                        endIcon={<CloseIcon />}
                        sx={webStyle.searchTextFont}
                        onClick={() =>
                          removeFilter(
                            data,
                            selectedFilters.subject,
                            updateSubject
                          )
                        }
                      >
                        {/* {data} */}
                        {toTitleCase(
                          data.split(",").reverse().join(" ").replace(",", "")
                        )}
                      </Button>
                    </Stack>
                  ))
                : null}

              {/* Author filter */}
              {selectedFilters.author.length
                ? selectedFilters.author?.map((data: string) => (
                    <Stack direction={"row"} alignItems="center">
                      <Button
                        size="small"
                        variant="outlined"
                        endIcon={<CloseIcon />}
                        sx={webStyle.searchTextFont}
                        onClick={() =>
                          removeFilter(
                            data,
                            selectedFilters.author,
                            updateAuthor
                          )
                        }
                      >
                        {toTitleCase(
                          data.split(",").reverse().join(" ").replace(",", "")
                        )}
                      </Button>
                    </Stack>
                  ))
                : null}

              {/* SPEAKER */}
              {selectedFilters.speaker.length
                ? selectedFilters.speaker?.map((data: string) => (
                    <Stack direction={"row"} alignItems="center">
                      <Button
                        size="small"
                        variant="outlined"
                        endIcon={<CloseIcon />}
                        sx={webStyle.searchTextFont}
                        onClick={() =>
                          removeFilter(
                            data,
                            selectedFilters.speaker,
                            updateSpeaker
                          )
                        }
                      >
                        {/* {data} */}
                        {toTitleCase(
                          data.split(",").reverse().join(" ").replace(",", "")
                        )}
                      </Button>
                    </Stack>
                  ))
                : null}

              {/* Guidek */}
              {selectedFilters.research.length
                ? selectedFilters.research?.map((data: string) => (
                    <Stack direction={"row"} alignItems="center">
                      <Button
                        size="small"
                        variant="outlined"
                        endIcon={<CloseIcon />}
                        sx={webStyle.searchTextFont}
                        onClick={() =>
                          removeFilter(
                            data,
                            selectedFilters.research,
                            updateResearch
                          )
                        }
                      >
                        {/* {data} */}
                        {toTitleCase(
                          data.split(",").reverse().join(" ").replace(",", "")
                        )}
                      </Button>
                    </Stack>
                  ))
                : null}
              {/* Journal */}
              {selectedFilters.journal.length
                ? selectedFilters.journal?.map((data: string) => (
                    <Stack direction={"row"} alignItems="center">
                      <Button
                        size="small"
                        variant="outlined"
                        endIcon={<CloseIcon />}
                        sx={webStyle.searchTextFont}
                        onClick={() =>
                          removeFilter(
                            data,
                            selectedFilters.journal,
                            updateJournal
                          )
                        }
                      >
                        {/* {data} */}
                        {toTitleCase(
                          data.split(",").reverse().join(" ").replace(",", "")
                        )}
                      </Button>
                    </Stack>
                  ))
                : null}
              {/* Journal Rank */}
              {selectedFilters.journalRank.length
                ? selectedFilters.journalRank?.map((data: string) => (
                    <Stack direction={"row"} alignItems="center">
                      <Button
                        size="small"
                        variant="outlined"
                        endIcon={<CloseIcon />}
                        sx={webStyle.searchTextFont}
                        onClick={() =>
                          removeFilter(
                            data,
                            selectedFilters.journalRank,
                            updateJournalRank
                          )
                        }
                      >
                        {/* {data} */}
                        {toTitleCase(
                          data.split(",").reverse().join(" ").replace(",", "")
                        )}
                      </Button>
                    </Stack>
                  ))
                : null}
              {selectedFilters.sourceIndexType?.length
                ? selectedFilters.sourceIndexType?.map((data: string) => (
                    <Stack direction={"row"} alignItems="center">
                      <Button
                        size="small"
                        variant="outlined"
                        endIcon={<CloseIcon />}
                        sx={webStyle.searchTextFont}
                        onClick={() =>
                          removeFilter(
                            data,
                            selectedFilters.sourceIndexType,
                            updateSourceIndexType
                          )
                        }
                      >
                        {/* {data} */}
                        {toTitleCase(
                          data.split(",").reverse().join(" ").replace(",", "")
                        )}
                      </Button>
                    </Stack>
                  ))
                : null}
              {/* Country of Publication */}
              {selectedFilters.countryOfPublication.length
                ? selectedFilters.countryOfPublication?.map((data: string) => (
                    <Stack direction={"row"} alignItems="center">
                      <Button
                        size="small"
                        variant="outlined"
                        endIcon={<CloseIcon />}
                        sx={webStyle.searchTextFont}
                        onClick={() =>
                          removeFilter(
                            data,
                            selectedFilters.countryOfPublication,
                            updateCountryOfPublication
                          )
                        }
                      >
                        {/* {data} */}
                        {toTitleCase(
                          data.split(",").reverse().join(" ").replace(",", "")
                        )}
                      </Button>
                    </Stack>
                  ))
                : null}
              {/* Country of Publication Author */}
              {selectedFilters.countryOfPublishingAuthor.length
                ? selectedFilters.countryOfPublishingAuthor?.map(
                    (data: string) => (
                      <Stack direction={"row"} alignItems="center">
                        <Button
                          size="small"
                          variant="outlined"
                          endIcon={<CloseIcon />}
                          sx={webStyle.searchTextFont}
                          onClick={() =>
                            removeFilter(
                              data,
                              selectedFilters.countryOfPublishingAuthor,
                              updateCountryOfPublishingAuthor
                            )
                          }
                        >
                          {/* {data} */}
                          {toTitleCase(
                            data.split(",").reverse().join(" ").replace(",", "")
                          )}
                        </Button>
                      </Stack>
                    )
                  )
                : null}

              {/* Publishers */}
              {selectedFilters.publisher.length
                ? selectedFilters.publisher?.map((data: string) => (
                    <Stack direction={"row"} alignItems="center">
                      <Button
                        size="small"
                        variant="outlined"
                        endIcon={<CloseIcon />}
                        sx={webStyle.searchTextFont}
                        onClick={() =>
                          removeFilter(
                            data,
                            selectedFilters.publisher,
                            updatePublisher
                          )
                        }
                      >
                        {/* {data} */}
                        {toTitleCase(
                          data.split(",").reverse().join(" ").replace(",", "")
                        )}
                      </Button>
                    </Stack>
                  ))
                : null}
              {/* Institutions */}
              {selectedFilters.institutions.length
                ? selectedFilters.institutions?.map((data: string) => (
                    <Stack direction={"row"} alignItems="center">
                      <Button
                        size="small"
                        variant="outlined"
                        endIcon={<CloseIcon />}
                        sx={webStyle.searchTextFont}
                        onClick={() =>
                          removeFilter(
                            data,
                            selectedFilters.institutions,
                            updateInstitution
                          )
                        }
                      >
                        {/* {data} */}
                        {toTitleCase(
                          data.split(",").reverse().join(" ").replace(",", "")
                        )}
                      </Button>
                    </Stack>
                  ))
                : null}
              {selectedFilters.yearFrom.length ? (
                <Stack direction={"row"} alignItems="center">
                  <Button
                    size="small"
                    variant="outlined"
                    endIcon={<CloseIcon />}
                    sx={webStyle.searchTextFont}
                    onClick={() =>
                      removeFilter(
                        Array.isArray(selectedFilters.yearFrom)
                          ? selectedFilters.yearFrom[0]
                          : selectedFilters.yearFrom,
                        Array.isArray(selectedFilters.yearFrom)
                          ? selectedFilters.yearFrom
                          : [selectedFilters.yearFrom],
                        updateYearFrom
                      )
                    }
                  >
                    {/* {data} */}
                    {`Publication date:${selectedFilters.yearFrom}`}
                  </Button>
                </Stack>
              ) : null}
            </Box>

            <Button
              variant="outlined"
              sx={{ ...webStyle.button, display: { xs: "none", sm: "flex" } }}
              onClick={onNewSearch}
            >
              New Author Search
            </Button>
          </Item>
        </Box>

        <Box sx={{ display: { xs: "contents", sm: "none" } }}>
          <Item
            sx={{
              flexShrink: 0,
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
            }}
          >
            <Box
              sx={[
                webStyle.flexRow,
                {
                  marginTop: "1%",
                  marginBottom: "1%",
                  flexWrap: "wrap",
                  gap: { xs: 0, sm: 1 },
                  alignItems: "center",
                  flexDirection: "row",
                },
              ]}
            >
              <Button sx={webStyle.clearallText} onClick={clearAll}>
                Clear All
              </Button>

              <Box sx={{ display: { xs: "flex", sm: "none" } }}>
                {ResponsiveFilterButtons({
                  filterArrays: [
                    {
                      data: authorReducer.searchTerm,
                      updateFunction: (data: string) => onRemove(data),
                    },
                    {
                      data: selectedFilters.sourceType,
                      updateFunction: (data: string) =>
                        removeFilter(
                          data,
                          selectedFilters.sourceType,
                          updateSourceType
                        ),
                    },
                    {
                      data: selectedFilters.subject,
                      updateFunction: (data: string) =>
                        removeFilter(
                          data,
                          selectedFilters.subject,
                          updateSubject
                        ),
                    },
                    {
                      data: selectedFilters.author,
                      updateFunction: (data: string) =>
                        removeFilter(
                          data,
                          selectedFilters.author,
                          updateAuthor
                        ),
                    },
                    {
                      data: selectedFilters.speaker,
                      updateFunction: (data: string) =>
                        removeFilter(
                          data,
                          selectedFilters.speaker,
                          updateSpeaker
                        ),
                    },
                    {
                      data: selectedFilters.research,
                      updateFunction: (data: string) =>
                        removeFilter(
                          data,
                          selectedFilters.research,
                          updateResearch
                        ),
                    },
                    {
                      data: selectedFilters.journal,
                      updateFunction: (data: string) =>
                        removeFilter(
                          data,
                          selectedFilters.journal,
                          updateJournal
                        ),
                    },
                    {
                      data: selectedFilters.journalRank,
                      updateFunction: (data: string) =>
                        removeFilter(
                          data,
                          selectedFilters.journalRank,
                          updateJournalRank
                        ),
                    },
                    {
                      data: selectedFilters.countryOfPublication,
                      updateFunction: (data: string) =>
                        removeFilter(
                          data,
                          selectedFilters.countryOfPublication,
                          updateCountryOfPublication
                        ),
                    },
                    {
                      data: selectedFilters.countryOfPublishingAuthor,
                      updateFunction: (data: string) =>
                        removeFilter(
                          data,
                          selectedFilters.countryOfPublishingAuthor,
                          updateCountryOfPublishingAuthor
                        ),
                    },
                    {
                      data: selectedFilters.publisher,
                      updateFunction: (data: string) =>
                        removeFilter(
                          data,
                          selectedFilters.publisher,
                          updatePublisher
                        ),
                    },
                    {
                      data: selectedFilters.institutions,
                      updateFunction: (data: string) =>
                        removeFilter(
                          data,
                          selectedFilters.institutions,
                          updateInstitution
                        ),
                    },
                  ],
                  configButtons: buttonConfigs,
                })}
              </Box>
            </Box>
          </Item>
        </Box>

        {/* bottom text */}
        {/* @ts-ignore */}
      </Box>
    </Box>
  );
};

export default AuthorFinderTopbar;

const webStyle = {
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  textResult: {
    fontFamily: { xs: "Helvetica Neue", sm: "Lora" },
    fontWeight: "700",
    fontSize: { xs: "1.25rem", sm: 24 },
    color: Colors.black,
    alignSelf: "center",
    backgroundColor: "green",
  },
  toogleText: {
    fontFamily: { xs: "Helvetica Neue", sm: "Inter" },
    fontWeight: "500",
    marginLeft: { xs: "0%", sm: "20%" },
    fontSize: { xs: "1.1rem", sm: "18px" },
  },
  clearallText: {
    fontSize: { xs: "0.878rem", sm: "16px" },
  },
  searchTextContainer: {
    marginLeft: "1%",
    border: 1,
    borderColor: Colors.gray_400,
    borderRadius: 1,
  },
  searchText: {
    // padding:"0.1%"
    // padding:0.5
  },
  searchTextFont: {
    fontFamily: "Inter",
    fontWeight: 500,
    color: Colors.gray900,
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    borderColor: Colors.gray_400,
    marginLeft: 1,
    textTransform: "none",
    paddingTop: 0,
    paddingBottom: 0,
    minHeight: 22,
    borderRadius: "6px",
    fontSize: { xs: "0.878rem", sm: "14px" },
  },
  button: {
    marginLeft: "0.9%",
    padding: "0.7rem",
    width: { xs: "100%", sm: "27%", md: "27%", lg: "12%" },
    fontWeight: 500,
    fontSize: { xs: "14px", sm: "16px" },
    minWidth: { xs: "91px", md: "189px" },
    height: "51px",
  },
  inputField: {
    width: "77%",
    marginRight: "1%",
    borderRadius: 60,
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: Colors.coolGray300,
        borderRadius: 2,
      },
    },
    fontFamily: "Helvetica Neue",
    fontSize: "0.875rem",
  },
};
